import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { useEditingProps, useEditItem, useGetZ3kObject } from '../utils/unpack-props';
import { UserRole } from 'z3k-config';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Box } from '@mui/material';
import { FlagSelectors } from 'console/device-settings/z3k/components/material-utils/flag-selector';
import { guardZonesOptionsSelector, usersOptionsSelector, } from 'console/device-settings/z3k/components/utils/z3k-selectors';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { MultipleSelectionTable, } from '../material-utils/multiple-selection-table/multiple-selection';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { removeNulls } from 'utils';
export const UserRoleComponent = memo(function UserRoleComponentImpl() {
    const z3k_name = 'user_roles';
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const onChange = useEditItem(id, z3k_name);
    const { config } = useContext(Z3KSettingsEditor);
    const { device_spec } = useContext(Z3KSettings);
    const guard_zones_options = guardZonesOptionsSelector(config);
    const users_options = usersOptionsSelector(config);
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const zoneEditingProps = useEditingProps(id, z3k_name, 'managed_guard_zone_list');
    const userListEditingProps = useEditingProps(id, z3k_name, 'user_list');
    const bits = useMemo(() => removeNulls([
        {
            bit: UserRole.AccessLevel.SMS,
            label: 'По смс',
            help_id: 'user_roles_access_level_register_sms',
        },
        {
            bit: UserRole.AccessLevel.WEB,
            label: 'Через личный кабинет',
            help_id: 'user_roles_access_level_register_cabinet',
        },
        device_spec.show_voice_notifications
            ? {
                bit: UserRole.AccessLevel.VOICE_MENU,
                label: 'Через голосовое меню',
                help_id: 'user_roles_access_level_register_voice_menu',
            }
            : null,
    ]), [device_spec]);
    const multipleSelectionTableOptions = useMemo(() => {
        return [
            {
                title: 'Список охранных зон, доступных для управления',
                help_id: 'user_roles_managed_guard_zone_list',
                options: guard_zones_options,
                z3k_field: 'managed_guard_zone_list',
            },
            {
                title: 'Список пользователей, которые имеют данную роль',
                help_id: 'user_roles_user_list',
                options: users_options,
                z3k_field: 'user_list',
            },
        ];
    }, [item]);
    const onChangeSettingRegister = useCallback((new_params) => {
        onChange({ ...item, access_level_register: new_params });
    }, [onChange, item]);
    return (_jsx(ErrorBoundary, { children: _jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [_jsx(Box, { width: "50%", children: _jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "users_name", ...nameEditingProps }) }), _jsx(FlagSelectors, { label: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043E\u0445\u0440\u0430\u043D\u043E\u0439", value: item.access_level_register, onChange: onChangeSettingRegister, bits: bits }), _jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: z3k_name, notification: false })] }) }));
});
